import React, { FC } from 'react';
import { Procedure as ProcedureT } from '../../../../../../types/Procedure';
import { Anesthesiologist, Physician } from '../../anesthesiologist/Personnel';
import { Bed } from '../../Patient';
import { PatientStat } from '../../shared/PatientStat';
import { useStatusColor } from '@/hooks/useStatusColor';
import { Box, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { formatDuration, shouldHighlightPhysicianInOr } from '../../shared/procedureUtils';

const Label = ({ text, backgroundColor }: { text: string; backgroundColor: string | null }) => (
  <Box borderRadius={4} bgcolor={backgroundColor || ''} style={{ fontWeight: 'bold', color: 'white' }} px={0.5}>
    {text}
  </Box>
);

const CardTiny: FC<{
  procedure: ProcedureT;
  physicianName?: string;
  anesthesiologistName?: string;
  anesthesiaType?: string;
  color: string;
  status: string;
  showBedNumber: boolean;
  hideStartTime?: boolean;
  inOrStatus: string;
  roomTime?: any;
  hospitalId?: number;
  timelineViewRoomTime?: boolean | null;
  isFlipRoom?: boolean;
}> = ({
  procedure,
  physicianName,
  anesthesiologistName,
  anesthesiaType,
  color,
  status,
  hideStartTime,
  showBedNumber,
  inOrStatus,
  roomTime,
  hospitalId,
  timelineViewRoomTime,
  isFlipRoom,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const getColor = useStatusColor('schedule');

  const highlightPhysician = shouldHighlightPhysicianInOr({
    orId: procedure?.orId,
    physicianCurrentRoomId: procedure?.physician?.currentRoomId,
    patientRoomId: procedure?.patient?.room?.id,
    status,
    requirePatientInOr: true,
  });

  return (
    <Box className={classes.header}>
      {!hideStartTime && <div className={classes.startTime}>{procedure?.startTimeText}</div>}
      <Box className={classes.content}>
        <Physician physicianName={physicianName} color={color} inline highlight={highlightPhysician} />
        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
          <Anesthesiologist
            procedureId={procedure.id}
            anesthesiologistName={anesthesiologistName}
            anesthesiaType={anesthesiaType}
            inline
            style={{ fontWeight: 400 }}
          />
          {/*<PatientName*/}
          {/*  name={procedure?.patient?.name || procedure?.patientName}*/}
          {/*  age={get(procedure, 'patientAge')}*/}
          {/*  sex={get(procedure, 'patientSex')}*/}
          {/*  inline*/}
          {/*/>*/}
          <PatientStat inline right>
            {/* {isCanceled ? 'Canceled' : noShow ? 'NoShow' : status} */}
            {!!roomTime &&
              timelineViewRoomTime &&
              formatDuration(roomTime, new Date(), false, {
                fontSize: '0.75rem',
                fontFamily:
                  'Rubik,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
              })}{' '}
            {isFlipRoom && <Label backgroundColor="#6c9911" text="FR" />}
            <Label
              backgroundColor={getColor(status, hospitalId, theme.palette.primary.light)}
              text={inOrStatus ? inOrStatus : status}
            />
            {showBedNumber && !!procedure?.patient?.bed && <Bed bed={procedure?.patient?.bed} />}
          </PatientStat>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    lineHeight: 'normal',
    alignItems: 'center',
    paddingLeft: '0.375em',
    height: '100%',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
  },
  startTime: {
    minWidth: '3em',
  },
}));

export default CardTiny;
